__turbopack_context__.v({
  "banner": "ArticleHeaderBanner-module-scss-module__o8-1Jq__banner",
  "image": "ArticleHeaderBanner-module-scss-module__o8-1Jq__image",
  "inner": "ArticleHeaderBanner-module-scss-module__o8-1Jq__inner",
});
